import { createReducer } from '@reduxjs/toolkit'
import { types } from 'actions/form_builder_actions'
import { deleteItem, ElementTransporter, moveRowItem } from './helpers'

const reducer = createReducer({}, (builder) => {
  builder
    .addCase(types.INIT, (state, action) => {
      Object.assign(state, action.initProps)
    })
    .addCase(types.UPDATE_FORM_ATTRS, (state, action) => {
      if (!state.data) state.data = {}
      state.data.attrs = action.attrs
    })
    .addCase(types.MOVE_ROW_ITEM, (state, action) => {
      moveRowItem(state, action)
    })
    .addCase(types.MOVE_ELEMENT_ITEM, (state, action) => {
      const transporter = new ElementTransporter(state)
      transporter.move(action)
    })
    .addCase(types.ADD_ROW_ITEM, (state, action) => {
      if (!state.data) state.data = {}
      if (!state.data.rows) state.data.rows = []
      state.data.rows.push(action.row)
    })
    .addCase(types.UPDATE_ROW_ITEM, (state, action) => {
      const [rowIndex] = action.path || []
      if (state.data?.rows?.[rowIndex] !== undefined) {
        state.data.rows[rowIndex] = action.updatedRow
      }
    })
    .addCase(types.UPDATE_CELL_ITEM, (state, action) => {
      const [rowIndex, cellIndex] = action.path || []
      if (state.data?.rows?.[rowIndex]?.cells?.[cellIndex] !== undefined) {
        state.data.rows[rowIndex].cells[cellIndex] = action.updatedCell
      }
    })
    .addCase(types.UPDATE_ELEMENT_ITEM, (state, action) => {
      const [rowIndex, cellIndex, elementPosition] = action.path || []
      if (state.data?.rows?.[rowIndex]?.cells?.[cellIndex]?.elements?.[elementPosition] !== undefined) {
        state.data.rows[rowIndex].cells[cellIndex].elements[elementPosition] = action.updatedElement
      }
    })
    .addCase(types.DELETE_ROW_ITEM, (state, action) => {
      deleteItem(state, ['data', 'rows', action.pos])
    })
    .addCase(types.DELETE_CELL_ITEM, (state, action) => {
      const [rowIndex, cellIndex] = action.path || []
      deleteItem(state, ['data', 'rows', rowIndex, 'cells', cellIndex])
    })
    .addCase(types.DELETE_ELEMENT_ITEM, (state, action) => {
      const [rowIndex, cellIndex, elementPosition] = action.path || []
      deleteItem(state, ['data', 'rows', rowIndex, 'cells', cellIndex, 'elements', elementPosition])
    })
    .addCase(types.SAVE, (state, action) => {
      if (action.data?.rows) {
        state.data = action.data
      }
    })
})

const initialHistoryState = {
  past: [],
  present: {},
  future: []
}

const historyReducer = createReducer(initialHistoryState, (builder) => {
  builder
    .addCase(types.UNDO, (state) => {
      if (state.past.length > 0) {
        const newPresent = state.past[state.past.length - 1]
        state.future.unshift(state.present)
        state.present = newPresent
        state.past.pop()
      }
    })
    .addCase(types.REDO, (state) => {
      if (state.future.length > 0) {
        const newPresent = state.future[0]
        state.past.push(state.present)
        state.present = newPresent
        state.future.shift()
      }
    })
    .addDefaultCase((state, action) => {
      // Apply the reducer to present state
      const newPresent = reducer(state.present, action)
      
      if (action.type === types.SAVE) {
        // Reset history on save
        state.past = []
        state.future = []
        state.present = newPresent
      } else {
        // Normal history update - replicate original logic
        // Original: state.get('present').isEmpty() ? List([]) : state.get('past').push(state.get('present'))
        const isEmpty = !state.present || Object.keys(state.present).length === 0
        if (!isEmpty) {
          state.past.push(state.present)
        }
        state.present = newPresent
        state.future = []
      }
    })
})

export default historyReducer
